import { colors } from '@cabonline/ui-shared';
import styled from '@emotion/styled';

export const StyledRequired = styled.span`
  color: ${colors.red};
  &:after {
    content: '*';
  }
`;
